import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { StringResult } from '../module-thryve/thryve.service';
import { ErrorService } from './error.service';
import { TermsAndConditions, TermsFunc, UnregisterFunc } from './webapiclient.service';

@Injectable({
  providedIn: 'root'
})
export class UnregisterService {

  constructor(
    private unregisterFunc: UnregisterFunc,
    private errorService: ErrorService

  ) { }
async unregister(value: string) {
    let result;
 return new Promise((resolve, reject) => {
     this.unregisterFunc.unregister(value).pipe(first()).subscribe({
        next: (v) => result = v,
        error: (e) => reject(e),
        complete: () => {
          if (result.body === "OK") {
            resolve("OK");
          } else {
            reject(result.body);
          }
        }
      })
 });
 }

 async getUnregisterDate(id: string) {
    let model: StringResult = {} as StringResult;
    return new Promise((resolve, reject) => {
        this.unregisterFunc.getUnregisterDate(id).pipe(first()).subscribe({
            next: (v) => model = v,
            error: (e) => reject(e.message),
            complete: () => resolve(model)
          })
    });
  }

async cancelUnregister() {
    let model: StringResult = {} as StringResult;
    return new Promise((resolve, reject) => {
        this.unregisterFunc.cancelUnregister().pipe(first()).subscribe({
            next: (v) => model = v,
            error: (e) => reject(e.message),
            complete: () => resolve(model)
          })
    });
  }

}
